import { useAtom } from "jotai";
import { useEffect } from "react";
import { selectionContextAtom } from "../components/Infrastructure/Site/state";
import { InfrastructureListPage } from "../components/Infrastructure/Table";
import { DashboardContainer, DashboardHeader } from "../ui/DashboardComponents";
import { PermissionGate } from "./PermissionGate";

export const InfrastructurePageV2 = () => {
    const [_, setSelectionContext] = useAtom(selectionContextAtom);

    useEffect(() => {
        setSelectionContext({});
    }, [setSelectionContext]);

    return (
        <PermissionGate permission="infrastructureView">
            <DashboardContainer>
                <DashboardHeader title="Infrastructure" actions={[]} />
                <InfrastructureListPage />
            </DashboardContainer>
        </PermissionGate>
    );
};
